
import { defineComponent } from 'vue';

export default defineComponent({
    mounted() {
        window.scrollTo(0, 0);
    },
    methods: {
        onDone() {
            this.$router.push({
                name: 'TrailerAssessment',
                query: this.$route.query,
            });
        },
    },
});
